<div *ngIf="this.getNotification() !== ''">
  <div class="alert_outer">
    <div class="alert__inner" [innerHTML]="this.getNotification()"></div>
  </div>
</div>
